import React, { useState, useEffect } from "react";
import {
  Collapse, Form, Input, Select, Badge, Space, Row, Col
} from "antd";
import { QuestionCircleOutlined, EyeOutlined } from "@ant-design/icons";
import UploadButton from "../common/UploadButton";
import globalData from "../../config/global_data";
import ImagePreviewModal from "../common/ImagePreviewModal";
const { Panel } = Collapse;


const KitProductItem = ({ kitProduct, product, onRemove, onUpdate, defaultImage, form, mainImage, setProduct , index }) => {
  const [data, setData] = useState(null);
  const [savedimages, setSavedimgaes] = useState(null);
  const [imageObj, setImageObj] = useState(null);
  const [thumnailMainImage, setThumnailMainImage] = useState(null);
  const [selectedSKU, setSelectedSKU] = useState([]);
  const [isPreviewVisible, setPreviewVisible] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [previewMeta, setPreviewMeta] = useState("");
  // const [form] = Form.useForm();
  const [options, setOptions] = useState([]);
  useEffect(() => {
    if (product) {
      setData(product)

      if (globalData && globalData?.bc_sku_list?.length > 0) {
        let optionsdata = globalData.bc_sku_list.filter(item => item.store_id === product.store_id)
        setOptions(optionsdata);
        if (product.name) {
          setSelectedSKU(product.value);
        }
        if (defaultImage) {
          setImageObj({ img_data: [defaultImage] })
        }
        if (mainImage) {
          setThumnailMainImage({ img_data: [mainImage] })
        }
      }
      // setImageObj({ img_data: [product.image] })
      form.setFieldsValue({
        kitSKUs: product.value,
      });


    }
  }, []);
  useEffect(() => {
    if (data) {      
      let updated_products = kitProduct.map(item =>
        item.id === product.id ? { ...item, ...data } : item
      );
      setProduct(updated_products);
    }
  }, [data, setProduct]);

  useEffect(() => {
    if (savedimages && savedimages.image_data && savedimages.image_data.length > 0) {
      setData({ ...data, image: savedimages.image_data[0] })
    }
    if (savedimages && savedimages.image_data && savedimages.image_data.length == 0) {
      setData({ ...data, image: null })
    }
  }, [savedimages])

  const onPreview = async (file) => {
    let src = file.url || file.thumbUrl;
    let sizeFormatted = 'Unknown size';


    // Try to fetch image size if URL exists
    if (src && !file.originFileObj) {
      try {
        const response = await fetch(src, { method: 'HEAD' }); // HEAD request only fetches headers
        const size = response.headers.get('content-length');
        if (size) {
          sizeFormatted = `${(parseInt(size, 10) / 1024).toFixed(1)} kB`;
        }
      } catch (err) {
        console.warn('Could not fetch file size:', err);
      }
    } else if (file.originFileObj?.size) {
      sizeFormatted = `${(file.originFileObj.size / 1024).toFixed(1)} kB`;
    }

    // Load image for dimensions
    const image = new Image();
    image.src = src;
    image.onload = () => {
      const format = file.name?.split('.').pop().toUpperCase() || 'IMG';
      const dimensions = `${image.naturalWidth} x ${image.naturalHeight}`;
      const meta = `${format} | ${dimensions} | ${sizeFormatted}`;
      setPreviewMeta(meta);
    };

    setPreviewImageUrl(src);
    setPreviewTitle(file.name || 'Image Preview');
    setPreviewVisible(true);
  };

  const onCopyLink = () => {
    if (previewImageUrl) {
      navigator.clipboard.writeText(previewImageUrl).then(() => {
      }).catch((err) => {
        console.error("Failed to copy link:", err);
      });
    }
  };

  const onDownload = async () => {
    if (!previewImageUrl) return;

    try {
      const response = await fetch(previewImageUrl, { mode: 'cors' });
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = previewTitle || "image.jpg";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url); // clean up
    } catch (err) {
      console.error("Failed to download image:", err);
    }
  };
  const handleImageClick = () => {

    setPreviewImageUrl(thumnailMainImage.img_data[0]);
    setPreviewVisible(true);
  };



  const handleNameChange = (e) => {
    setData({ ...data, name: e.target.value })
    onUpdate(product.id, { name: e.target.value });
  };

  const handleChange = async (value) => {
    try {
      setSelectedSKU(value);

      const selecteddata = options.find(item => item.value == value);
      if (selecteddata) {
        const updatedData = {
          ...data,
          name: selecteddata.product_name,
          value: value,
          mainImage: selecteddata.image,
          msrp: selecteddata.msrp,
          sale_price: selecteddata.sale_price,
          store_id: product.store_id
        };
        setThumnailMainImage({ img_data: [mainImage] })
        setData(updatedData);
        onUpdate(product.id, updatedData);
      }
    } catch (error) {
      console.error("handleChange error:", error);
    }
  };

  const collapseItems = [
    {
      key: product.id,
      label: data && (
        <span style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <span>{data.name}</span>
          {
            product.is_primary ? (
              <span style={{ textAlign: 'right' }}>
                <Badge
                  className="site-badge-count-109"
                  count="Primary"
                  style={{ backgroundColor: '#008000', padding: "2px 8px", height: "auto" }}
                />
              </span>
            ) : null
          }
        </span>
      ),
      children: data && (
        <>
          <Form.Item
            label="Product Name"
            name={`productName${data.value}`}
            rules={[{ required: true }]}
            initialValue={data.name}
          >
            <Input
              placeholder="New Product"
              value={data.name}
              onChange={handleNameChange}
              disabled
              maxLength={150}
            />
          </Form.Item>

          <Form.Item
            label="SKU"   
            initialValue={data.value}
            name={['products', index, 'kitSKUs']}
            rules={[{ required: true, message: "Please Select SKU" }]}      
          >
            <Select              
              showSearch
              optionFilterProp="label"
              style={{ width: "100%" }}
              placeholder="Select SKU"
              onChange={handleChange}
              options={options}
              value={selectedSKU}
            />
          </Form.Item>

          <Row gutter={8}>
            <Col span={12}>
              <Form.Item
                label={
                  <span>
                    Store MSRP&nbsp;                    
                  </span>
                }
              >
                <Input placeholder="Enter MSRP" value={data.msrp} disabled
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <span>
                    Store Sale Price&nbsp;                   
                  </span>
                }
              >
                <Input
                  placeholder="Enter Sale Price"
                  value={data.sale_price}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>

          {!data.is_primary && (
            <div className="WiththumnailMainImageBox">
              <Form.Item
                label={
                  <span>
                    PDP Gallery&nbsp;                   
                  </span>
                }
                name="PDPGallery"
                className="WiththumnailMainImage"
              >
                {thumnailMainImage?.img_data?.[0] && (
                  <div className="thumnailMainImageBox">
                    <div className="thumnailMainImageBoxInner" onClick={handleImageClick} style={{ cursor: "pointer" }}>
                      <div
                        className="thumnailRelative"
                        onClick={() =>
                          onPreview({
                            url: thumnailMainImage?.img_data?.[0],
                            name: "slider-image.jpg", // fake name
                          })
                        }
                        style={{ position: "relative", cursor: "pointer" }}
                      >
                        <img
                          className="thumnailImage"
                          src={thumnailMainImage.img_data[0]}
                          alt="Main Thumbnail"
                          style={{ width: "100px", height: "100px", objectFit: "contain" }}
                        />
                        <div

                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            color: '#fff',
                            borderRadius: '50%',
                            padding: 8,
                            cursor: 'pointer',
                            opacity: 0,
                            transition: 'opacity 0.3s',
                          }}
                          className="eye-hover"
                        >
                          <EyeOutlined style={{ fontSize: 20 }} />
                        </div>
                      </div>
                    </div>
                    <div className="thumnailName" style={{ marginTop: "4px" }}>
                      <Space size="small" align="center">
                        <span
                          style={{
                            height: 6,
                            width: 6,
                            backgroundColor: "#52c41a",
                            borderRadius: "50%",
                            display: "inline-block",
                          }}
                        />
                        <span>Slider Image</span>
                      </Space>
                    </div>
                  </div>
                )}

                <ImagePreviewModal
                  visible={isPreviewVisible}
                  onClose={() => setPreviewVisible(false)}
                  imageSrc={previewImageUrl}
                  title={previewTitle}
                  meta={previewMeta}
                  onCopyLink={onCopyLink}
                  onDownload={onDownload}
                />
                <UploadButton
                  setSavedimgaes={setSavedimgaes}
                  MAX_UPLOADS="1"
                  delete="true"
                  replace="true"
                  thumbnail="true"
                  hover="false"
                  product_obj={imageObj}
                />
              </Form.Item>
            </div>)
          }

        </>

      ),
    }
  ];


  return (
    <Collapse className="ProductDetailsCollapse_inner" items={collapseItems} />

  );
};

export default KitProductItem;
